export default "__VITE_ASSET__af01b73c__"